import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { MenuServices } from '../../../../menu/services';
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the ComboPartialDishesSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-combo-partial-dishes-selected',
    templateUrl: 'combo-partial-dishes-selected.html',
})
export class ComboPartialDishesSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public menuServices: MenuServices,
        public translate: TranslateService) {
    }

    deleteElement(index) {
        if (index >= 0) {
            this.menuServices.menu_dish_array_tmp.splice(index, 1);
            this.menuServices.menu_dish_array_tmp = [...this.menuServices.menu_dish_array_tmp];
        }
    }

    reorderElements(indexes) {
        var element = this.menuServices.menu_dish_array_tmp[indexes.from];
        this.menuServices.menu_dish_array_tmp.splice(indexes.from, 1);
        this.menuServices.menu_dish_array_tmp.splice(indexes.to, 0, element);
    }
}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-dish-select/combo-partial-dishes-selected/combo-partial-dishes-selected.ts